


export const products = {
    watch: {
        heading: 'WATCH',
        subHeading: 'Introducing our largest display yet',
        imageURL: 'https://www.apple.com/v/home/ag/images/promos/watch-series-7/tile_watch__e9n11b6m6yq2_large.jpg',
        learn: 'https://www.apple.com/in/watch/',
        buy: 'https://www.apple.com/in/watch/'
    },
    ipad: {
        heading: 'iPad mini',
        subHeading: 'Mega power. Mini sized',
        imageURL: 'https://www.apple.com/v/home/ag/images/promos/ipad-mini/promo_ipad_mini__spq4zjcuuaie_large.jpg',
        learn: 'https://www.apple.com/in/ipad-mini/',
        buy: 'https://www.apple.com/in/ipad-mini/'
    },
    airprods: {
        heading: 'AirPods',
        subHeading: 'All-new with Spatial Audio',
        imageURL: 'https://images.unsplash.com/photo-1568651872875-2b0352849bf6?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1036&q=80',
        learn: 'https://www.apple.com/in/airpods/',
        buy: 'https://www.apple.com/in/airpods/'
    },
    homepod: {
        heading: 'HomePod mini',
        subHeading: 'Yellow orange and blue available in late November',
        imageURL: 'https://www.apple.com/v/home/ag/images/promos/homepod-mini/tile_homepod_mini__b73w4z3ljymu_large.jpg',
        learn: 'https://www.apple.com/in/homapod/',
        buy: 'https://www.apple.com/in/homapod/'
    },
    arcade: {
        heading: 'Arcade',
        subHeading: 'Get 3 months free when you buy a new iPhone, iPad, iPod touch, Apple TV or Mac.',
        imageURL: 'https://www.apple.com/v/home/ag/images/promos/arcade-bundle/tile_arcade__ewkth5cd0wia_large.jpg',
        learn: 'https://www.apple.com/in/arcade/',
        buy: 'itms-apps://?action=arcade&itscg=10000&itsct=arc-0-arc_ovp-hero-apl-ref-220412'
    },
    appletv: {
        heading: 'APPLE TV',
        subHeading: 'Apple Originals ',
        imageURL: 'https://images.unsplash.com/photo-1592042221673-7320147c7482?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=774&q=80',
        learn: 'https://www.apple.com/tv-home/',
        buy: 'https://www.apple.com/tv-home/'
    }
}